<template>
	<div class="table-service">
		<div class="table-service-item">
			<!-- 替换修复 其他类型图标 -->
			<xl-icon is-button :size="24" color="var(--oem-color-n8)" class="icon-other1" v-if="row.designType === 'other'">
				<Other />
			</xl-icon>
			<xl-icon is-button :size="24" color="var(--oem-color-n8)" class="icon-other1" v-else-if="row.designType === 'repair'">
				<Restoration />
			</xl-icon>
			<i :class="`iconfont icon-${_get(serviceObj, row.designType + '.icon', '')}`" v-else-if="!_get(serviceObj, row.designType + '.svg')"></i>
      <svg class="icon svg-icon" aria-hidden="true" v-else>
        <use :xlink:href="`#icon-${_get(serviceObj, row.designType + '.icon', '')}`"></use>
      </svg>

			<span>{{ $t('user.case.type.' + row.designType) }}</span>
		</div>
	</div>
</template>

<script setup>
import _get from 'lodash/get';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import { serviceObj } from '../common/enum';
import { Restoration, Other } from '@shining3d/icons-vue';

const { $t } = useLang( '@shining3d/app' );
defineProps({
	row: {
		type: Object,
		default: () => ({})
	}
});

</script>

<style scoped lang="scss">
.table-service {
	display: flex;
	flex-wrap: wrap;
	margin: -4px;
	.table-service-item {
		display: flex;
		background-color: $color-b1;
		border-radius: 8px;
		height: 32px;
		line-height: 32px;
		align-items: center;
		padding: 0 10px;
		margin: 4px;
		white-space: nowrap;
    	color: $color-n9;
    .iconfont {
			margin-right: 4px;
			font-size: 18px;
		}
		svg {
			width: 18px;
			height: 18px;
			margin-right: 4px;
		}
	}
}
.icon-other1{
	line-height: 12px;
}
</style>
